import { SlackChannels } from '../../../pure-js/enums/SlackChannels.js'
import { notify } from '../NotifyHelper.js'

/**
 * Enhanced error logging with comprehensive context
 * @param error - The error object
 * @param user - User context (optional, will be extracted from error context if provided)
 * @param errorContext - Pre-built error context string (optional, will be built if not provided)
 */
export const error = (error: Error | any, user?: any, errorContext?: string) => {
  // If errorContext is provided, use it directly (from captureException)
  if (errorContext) {
    notify(errorContext, SlackChannels.OPS_ERRORS)
    return
  }

  // Fallback: build basic context if not provided
  const errorName = error?.name || 'UnknownError'
  const errorMessage = error?.message || error?.toString() || 'No error message'
  const errorStack = error?.stack || 'No stack trace available'
  const url = typeof window !== 'undefined' ? window.location.href : 'N/A'

  const phone = user && typeof user === 'object' && 'phone' in user ? (user as { phone?: string }).phone : undefined
  const userInfo = user
    ? `email: ${user.email || 'undefined'}, id: ${user.id || 'undefined'}, phone: ${phone || 'undefined'}`
    : 'email: undefined, id: undefined, phone: undefined'

  const context = [
    `user-web: ${userInfo}`,
    `Error: ${errorName}`,
    `Message: ${errorMessage}`,
    `URL: ${url}`,
    `Stack: ${errorStack}`
  ].join('\n')

  notify(context, SlackChannels.OPS_ERRORS)
}
